// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__LygNY","upload":"Small_upload__Zscgv","imageWrap":"Small_imageWrap__gNXha","removeBtn":"Small_removeBtn__nxcpC"};